import {timetable_syncTimetableDetailMaterials_Api} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify} from 'views/AppLocals/factory/createNotification'
import {TimetableDetailMaterialsForm} from './TimetableDetailMaterialsForm'

// Mirror useTimetableDetailSongsForm.js - quản lý link tài liệu bài giảng của 1 buổi cụ thể
// (timetable_detail), độc lập với sửa rule chung của Timetable cha.
export const useTimetableDetailMaterialsForm = ({onRefresh} = {}) => {
    const t = useTranslate()
    const [activeDetail, setActiveDetail] = useState(null)

    const onCancel = () => setActiveDetail(null)

    const {handleAsyncAction: onSync, isLoading} = useAsyncAction({
        apiInfo: timetable_syncTimetableDetailMaterials_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            if (onRefresh) onRefresh()
            onCancel()
        },
    })

    const handleManageMaterials = (timetableDetail) => setActiveDetail(timetableDetail)

    const modal = (
        <TimetableDetailMaterialsForm
            visible={!!activeDetail}
            item={activeDetail}
            loading={isLoading}
            onCancel={onCancel}
            onSubmit={(materials) => onSync({materials: JSON.stringify(materials)}, {id: activeDetail?.id})}
        />
    )

    return {modal, handleManageMaterials}
}
